import { getWeek } from 'date-fns';
import { useTranslation } from 'react-i18next';

export default function useRepeatsByPeriodicity({ periodicity, periodKey }) {
    const { t } = useTranslation('forecasts');

    const repeatersByPeriodicity = {
        yearly: {
            repeat_for: [
                {
                    label: t('periodicity.no-repeat'),
                    id: 1,
                },
                {
                    label: `2 ${t('periodicity.years')}`,
                    id: 2,
                },
                {
                    label: `5 ${t('periodicity.years')}`,
                    id: 5,
                },
                {
                    label: `10 ${t('periodicity.years')}`,
                    id: 10,
                },
            ],
            repeat_every: [
                {
                    label: t('periodicity.year'),
                    id: 1,
                },
                {
                    label: `2 ${t('periodicity.years')}`,
                    id: 2,
                },
            ],
        },
        quarterly: {
            repeat_for: [
                {
                    label: t('periodicity.no-repeat'),
                    id: 1,
                },
                {
                    label: '2 ' + t('periodicity.quarters'),
                    id: 2,
                },
                {
                    label: `1 ${t('periodicity.year')}`,
                    id: 4,
                },
                {
                    label: `2 ${t('periodicity.years')}`,
                    id: 8,
                },
            ],
            repeat_every: [
                {
                    label: t('periodicity.quarter'),
                    id: 1,
                },
                {
                    label: `2 ${t('periodicity.quarters')}`,
                    id: 2,
                },
                {
                    label: t('periodicity.year'),
                    id: 4,
                },
            ],
        },
        monthly: {
            repeat_for: [
                {
                    label: t('periodicity.no-repeat'),
                    id: 1,
                },
                {
                    label: `2 ${t('periodicity.months')}`,
                    id: 2,
                },
                {
                    label: `6 ${t('periodicity.months')}`,
                    id: 6,
                },
                {
                    label: `1 ${t('periodicity.year')}`,
                    id: 12,
                },
                {
                    label: `2 ${t('periodicity.years')}`,
                    id: 24,
                },
                {
                    label: t('periodicity.until-end-of-year'),
                    id: 12 - new Date(periodKey).getMonth(),
                },
            ],
            repeat_every: [
                {
                    label: t('periodicity.month'),
                    id: 1,
                },
                {
                    label: `2 ${t('periodicity.months')}`,
                    id: 2,
                },
                {
                    label: `3 ${t('periodicity.months')}`,
                    id: 3,
                },
                {
                    label: `6 ${t('periodicity.months')}`,
                    id: 6,
                },
                {
                    label: t('periodicity.year'),
                    id: 12,
                },
            ],
        },
        weekly: {
            repeat_for: [
                {
                    label: t('periodicity.no-repeat'),
                    id: 1,
                },
                {
                    label: `2 ${t('periodicity.weeks')}`,
                    id: 2,
                },
                {
                    label: `4 ${t('periodicity.weeks')}`,
                    id: 4,
                },
                {
                    label: `8 ${t('periodicity.weeks')}`,
                    id: 8,
                },
                {
                    label: `12 ${t('periodicity.weeks')}`,
                    id: 12,
                },
                {
                    label: t('periodicity.until-end-of-year'),
                    id: 52 - getWeek(new Date(periodKey)),
                },
            ],
            repeat_every: [
                {
                    label: t('periodicity.week'),
                    id: 1,
                },
                {
                    label: `2 ${t('periodicity.weeks')}`,
                    id: 2,
                },
                {
                    label: `4 ${t('periodicity.weeks')}`,
                    id: 4,
                },
                {
                    label: `12 ${t('periodicity.weeks')}`,
                    id: 12,
                },
            ],
        },
        daily: {
            repeat_for: [
                {
                    label: t('periodicity.no-repeat'),
                    id: 1,
                },
                {
                    label: `2 ${t('periodicity.days')}`,
                    id: 2,
                },
                {
                    label: `1 ${t('periodicity.week')}`,
                    id: 7,
                },
                {
                    label: `2 ${t('periodicity.weeks')}`,
                    id: 14,
                },
                {
                    label: `1 ${t('periodicity.month')}`,
                    id: 30,
                },
                {
                    label: t('periodicity.until-end-of-year'),
                    id: 365 - new Date(periodKey).getDate(),
                },
            ],
            repeat_every: [
                {
                    label: t('periodicity.day'),
                    id: 1,
                },
                {
                    label: `2 ${t('periodicity.days')}`,
                    id: 2,
                },
                {
                    label: t('periodicity.week'),
                    id: 7,
                },
                {
                    label: `2 ${t('periodicity.weeks')}`,
                    id: 14,
                },
                {
                    label: t('periodicity.month'),
                    id: 30,
                },
            ],
        },
    };

    return repeatersByPeriodicity[periodicity];
}
